import { expVal } from '@atlassian/jira-feature-experiments';
import { useAnalyticsEvents, fireTrackAnalytics } from '@atlassian/jira-product-analytics-bridge';
import { getHasXflowFromWhiteboardsTouchPoint } from '../../../state/selectors/whiteboards-entrypoint-experiment/index.tsx';
import { useBacklogSelector } from '../../../state/index.tsx';

import { NOT_ENROLLED, VARIATION, type Flow } from '../constants.tsx';
import { useIsCrossFlowEligibleAllJiras, useIsCoUseEligibleAllJiras } from '../utils.tsx';

type experimentEligibiltyProps = {
	flow: Flow;
	isVariantEligible: boolean;
};

export const useIsExperimentEligible = (): experimentEligibiltyProps => {
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const crossFlowEligible = useIsCrossFlowEligibleAllJiras();
	const coUseEligible = useIsCoUseEligibleAllJiras();
	const hasXflowFromWhiteboardsTouchpoint = useBacklogSelector(
		getHasXflowFromWhiteboardsTouchPoint,
	);

	let isVariantEligible = false;
	let cohort = NOT_ENROLLED;
	let flow: Flow = 'none';

	if (crossFlowEligible) {
		cohort = expVal('grw_1037_expand_plan_in_whiteboards', 'cohort', 'not-enrolled');
		fireTrackAnalytics(createAnalyticsEvent({}), 'expandPlanOnWhiteboardsToAllJiras exposed', {
			cohort,
		});
		if (cohort === VARIATION) {
			flow = 'crossFlow';
			isVariantEligible = true;
		}
	} else if (coUseEligible && hasXflowFromWhiteboardsTouchpoint) {
		flow = 'coUse';
		isVariantEligible = true;
	}

	return { flow, isVariantEligible };
};
